import React from 'react';
import classNames from 'classnames';

import { FormattedMessage } from '../../util/reactIntl';

import css from './PickupInfo.module.css';

/**
 * CL-STOCK-01 SL14 — the collection address, as text.
 *
 * Fuzzy locations are on marketplace-wide (D6), and SectionMapMaybe stops passing
 * the address to the map when fuzzy is on: it sends obfuscatedCenter only. That
 * map line was the only buyer-facing place publicData.location.address was read,
 * so without this component a buyer is asked to collect from a 500 m circle.
 *
 * Reads publicData directly, so it also works for listings saved before this
 * feature.
 *
 * @param {Object} props
 * @param {Object} props.publicData - listing publicData
 */
const PickupInfo = props => {
  const { className, rootClassName, publicData } = props;

  const address = publicData?.location?.address;
  if (!publicData?.pickupEnabled || !address) {
    return null;
  }

  const building = publicData.location.building;

  return (
    <div className={classNames(rootClassName || css.root, className)}>
      <h3 className={css.heading}>
        <FormattedMessage id="PickupInfo.heading" />
      </h3>
      <p className={css.address}>{[building, address].filter(Boolean).join(', ')}</p>
    </div>
  );
};

export default PickupInfo;
